import type { PaymentBatch } from "../../api/task_payment_api";

export function getPaymentBatchStatusColor(
  status: string
): "success" | "warning" | "error" | "default" {
  switch (status) {
    case "completed":
      return "success";
    case "partial":
      return "warning";
    case "processing":
      return "default";
    case "voided":
      return "error";
    default:
      return "default";
  }
}

// Mirrors FHPaymentBatch.VOIDABLE_STATUSES: a 'processing' run never finished,
// so it has no payment records to undo.
export function isPaymentBatchVoidable(status: PaymentBatch["status"]): boolean {
  return status === "completed" || status === "partial";
}
